import { render, staticRenderFns } from "./agentAdd.vue?vue&type=template&id=10df540c"
import script from "./agentAdd.vue?vue&type=script&lang=js"
export * from "./agentAdd.vue?vue&type=script&lang=js"
import style0 from "./agentAdd.vue?vue&type=style&index=0&id=10df540c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports